module.exports = __webpack_public_path__ + "img/delivery-icon.0e28463f.svg";